/**
 * Shared Scaledrone Configuration
 *
 * Constants for Scaledrone connection, batching, and event handling.
 * Used by both client (ScaledroneProvider, worker) and server (ScaledroneManager).
 */

export const SCALEDRONE_CONFIG = {
  /** Number of rooms to subscribe to per batch */
  BATCH_SIZE: 10,
  /** Delay between batches in ms */
  DELAY_BETWEEN_BATCHES_MS: 100,
  /** Maximum connection retry attempts before giving up */
  MAX_CONNECTION_ATTEMPTS: 3,
  /** Failed attempts before circuit breaker trips */
  CIRCUIT_BREAKER_THRESHOLD: 1,
  /** Timeout for connection attempts in ms */
  CONNECTION_TIMEOUT_MS: 10000,
  /** Maximum events to keep in the event store */
  MAX_EVENTS: 100,
  /** Interval for batching worker messages in ms */
  BATCH_INTERVAL_MS: 500,
} as const;
